export default __webpack_public_path__ + "static/media/coding.07d0bfa7.webp";